import dayjs from "dayjs";
export default class Helper {
  constructor() {}

  static isFloat(num) {
    return Number(num) === num && !Number.isInteger(num);
  }

  static ceilToTwoDecimalPlaces = (num) => {
    return num;
    // return Math.ceil(num * 100) / 100;
  };

  static getDiscountPrice(price, discountPercent) {
    if (discountPercent === 0) return parseFloat(price);
    const _price = parseFloat(price);
    const discountAmount = parseFloat((_price * discountPercent) / 100);
    const discountPrice = parseFloat((_price - discountAmount).toFixed(1));
    return discountPrice;
  }

  static get12HrTimeOnly(timeObj) {
    if (timeObj === undefined || timeObj === null) {
      return;
    }
    const isDayjs = timeObj && typeof timeObj === "object" && timeObj.isValid && timeObj.isValid();
    // Convert to 24-hour time string
    let time24;
    if (isDayjs) {
      time24 = timeObj.format("HH:mm a");
    } else if (typeof timeObj === "string") {
      time24 = timeObj;
    } else {
      throw new Error("Invalid input: Expected a dayjs object or a string in 'HH:mm' format");
    }

    let [hrs, mins] = time24.split(":").map(Number);
    const AM_PM = hrs >= 12 ? "PM" : "AM";
    hrs = hrs % 12 || 12;
    const time12 = `${String(hrs).padStart(2, "0")}:${String(mins).padStart(2, "0")} ${AM_PM}`;
    return time12;
  }

  static convertTo24HourFormat(timeString) {
    if (!timeString) {
      return "";
    }

    let hours, minutes;

    // Handle dayjs object
    if (dayjs.isDayjs(timeString)) {
      return timeString.format("HH:mm"); // Return directly as 'HH:mm'
    }

    // Handle 12-hour time string (e.g., '01:30 PM')
    const [timePart, modifier] = timeString.split(" "); // Split into time and AM/PM
    [hours, minutes] = timePart.split(":").map(Number); // Split hours and minutes

    hours = isNaN(hours) ? 0 : hours;
    minutes = isNaN(minutes) ? 0 : minutes;

    if (modifier === "PM" && hours !== 12) {
      hours += 12; // Add 12 for PM
    } else if (modifier === "AM" && hours === 12) {
      hours = 0; // Midnight case
    }

    return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;
  }

static isValidWebsiteUrl(url) {
  try {
    if (typeof url !== "string" || !url.trim()) return false;

    url = url.trim();

    // Add protocol if missing
    if (!/^https?:\/\//i.test(url)) {
      url = "http://" + url;
    }

    const parsed = new URL(url);
    const hostname = parsed.hostname.toLowerCase();

    // Reject localhost or IP addresses
    if (/^(localhost|(\d{1,3}\.){3}\d{1,3})$/.test(hostname)) return false;

    // Must contain a dot (.) in hostname
    if (!hostname.includes(".")) return false;

    // Get last part (TLD)
    const tld = hostname.split(".").pop();

    // Allow any alphabetic TLD (2–24 chars, covers most cases)
    if (!/^[a-z]{2,24}$/.test(tld)) return false;

    return true;
  } catch {
    return false;
  }
}


  static isValidSocialMedia(url) {
    try {
      // if user enters without http(s), prepend https://
      if (!/^https?:\/\//i.test(url)) {
        url = "https://" + url;
      }

      const parsed = new URL(url);
      const hostname = parsed.hostname.toLowerCase();

      const allowedDomains = [
        "facebook.com",
        "instagram.com",
        "twitter.com",
        "x.com",
        "linkedin.com",
        "tiktok.com",
        "youtube.com",
      ];

      return allowedDomains.some((domain) => hostname === domain || hostname.endsWith("." + domain));
    } catch {
      return false;
    }
  }

  static transformAdditionGroups = (data) => {
    return data.map((group) => ({
      additionGroupId: group.additionGroupId,
      additionGroupName: group.name,
      totalPriceOfSelectedItems: parseFloat(group.totalPriceOfSelectedItems || 0),
      initialNumberOfFreeItems: group.numberOfFreeItems || 0,
      numberOfFreeItems: group.numberOfFreeItems || 0,
      pricePerAddition: group.pricePerAddition,
      additionItems: (group.additionItems || []).map((item) => ({
        additionItemId: item.additionItemId,
        additionItemName: item.name,
        quantity: item.quantity,
      })),
    }));
  };

  /**
   * Calculate total price: (productPrice + sum(addOns prices)) * quantity
   * @param {Array} addOns - Array of add-on objects [{ price }]
   * @param {number} quantity - Main product quantity
   * @param {number|string} productPrice - Price of main product
   * @returns {number} Total price including product and add-ons
   */
  static calculateProductPriceWithAddOns = (addOns = [], quantity = 1, productPrice = 0) => {
    const basePrice = parseFloat(productPrice || 0);

    // Sum all add-ons prices
    const addOnsSum = addOns.reduce((sum, addOn) => sum + parseFloat(addOn.price || 0), 0);

    // Final formula
    return (basePrice + addOnsSum) * quantity;
  };
}
